module.exports = __webpack_public_path__ + "static/media/icon-corner-rounded.7f4bcfbf.svg";